/**
 * Processed media
 */

const initialState = () => ({
    items: [],
});

// state
export const processedState = {
    mediaprocessed: {
        ...initialState(),
    },
};

// mutations
export const processedMutations = {
    setMediaProcessedItems(state, items) {
        state.mediaprocessed.items = items;
    },
};

// getters
export const processedGetters = {
    getMediaProcessedItems(state) {
        return state.mediaprocessed.items;
    },
    getMediaProcessedItem: (state) => (id) => {
        const index = state.mediaprocessed.items.findIndex((item) => item.id === id);
        if (index > -1) {
            retVal = state.mediaprocessed.items[index];
        } else {
            retVal = index;
        }
        return retVal;
    },
};

// actions
export const processedActions = {
    addMediaProcessedFile({ state }, file) {
        //const itemIndex = state.uploadmodal.items.findIndex(item => item.id === file.id);
        //if (itemIndex > -1) {
        //    state.uploadmodal.items.splice(itemIndex, 1, file);
        //} else {
        state.mediaprocessed.items.push(file);
        //}
    },
    removeMediaProcessedFile({ state }, file) {
        const items = state.mediaprocessed.items;
        if (items) {
            const index = items.findIndex((item) => item.id === file.id);
            if (inxdex > -1) items.splice(index, 1);
        }
    },
};
